const LISTS = [
    {
        title: "What's New",
        elements: [
            {name: "Card Verification FAQ", link: "https://developer.moneris.com/More/Whats%20New/Card%20Verification%20FAQ"},
            {name: "Moneris Multi-Currency Pricing (MCP) – Common questions", link: "https://developer.moneris.com/More/Whats%20New/Moneris%20MCP"},
            {name: "URL Change Required for Moneris Gateway Batch File Transaction Processing", link: "https://developer.moneris.com/More/Whats%20New/MG%20URL%20Change"},
            {name: "MRC - Virtual Terminal Update", link: "https://developer.moneris.com/More/Whats%20New/MRC%20Virtual%20Terminal%20Update"},
            {name: "Accepting Digital Wallets", link: "https://developer.moneris.com/More/Whats%20New/Accepting%20Digital%20Wallets"}
        ]
    },
    {
        title: "Getting Started",
        elements: [
            {name: "Features Overview", link: "https://developer.moneris.com/More/Getting%20Started/Feature%20Overview"},
            {name: "GitHub API & Documentation Repository", link: "https://developer.moneris.com/More/Getting%20Started/GitHub%20API%20and%20Documentation%20Repository"}
        ]
    },
    {
        title: "Testing",
        elements: [
            {name: "Testing a Solution", link: "https://developer.moneris.com/More/Testing/Testing%20a%20Solution"},
            {name: "Testing 3-D Secure (MPI) Solutions", link: "https://developer.moneris.com/More/Testing/Testing%203D%20Solutions"},
            {name: "CVD & AVS (E-Fraud) Simulator", link: "https://developer.moneris.com/More/Testing/E-Fraud%20Simulator"},
            {name: "Error Messages & Response Codes", link: "https://developer.moneris.com/More/Testing/Error%20Messages%20and%20Response%20Codes"},
            {name: "Penny Value Simulator", link: "https://developer.moneris.com/More/Testing/Penny%20Value%20Simulator"},
            {name: "Response Handling", link: "https://developer.moneris.com/More/Testing/Response%20Handling"},
            {name: "Response Codes", link: "https://developer.moneris.com/More/Testing/Response%20Codes"},
            {name: "Card Level Result Values", link: "https://developer.moneris.com/More/Testing/Card%20Level%20Result%20Values"},
            {name: "CAVV Result Codes", link: "https://developer.moneris.com/More/Testing/CAVV%20Result%20Codes"},
            {name: "CVD Result Codes", link: "https://developer.moneris.com/More/Testing/CVD%20Result%20Codes"},
            {name: "AVS Result Codes", link: "https://developer.moneris.com/More/Testing/AVS%20Result%20Codes"},
            {name: "IP Addresses", link: "https://developer.moneris.com/More/Testing/IP%20Address"},
            {name: "QA Server Status", link: "https://developer.moneris.com/More/Testing/QA%20Server%20Status"},
            {name: "Receipt Requirements", link: "https://developer.moneris.com/More/Testing/Receipt%20Requirements"}
        ]
    },
    {
        title: "Register With Us",
        elements: [
            {name: "Become a Partner", link: "https://developer.moneris.com/More/Register/Become%20a%20Partner"},
            {name: "Integration Registration", link: "https://developer.moneris.com/More/Register/Integration%20Registration"},
            {name: "INTERAC® Online Certification", link: "https://developer.moneris.com/More/Register/Interac%20Online%20Certification"},
            {name: "Request Batch Upload Account", link: "https://developer.moneris.com/More/Register/Request%20Batch%20Upload"},
            {name: "Update QA Account", link: "https://developer.moneris.com/More/Register/Update%20QA%20Account"},
            {name: "Request Custom QA Account", link: "https://developer.moneris.com/More/Register/Request%20Custom%20QA%20Account"}
        ]
    },
    {
        title: "Compliance",
        elements: [
            {name: "Application Security", link: "https://developer.moneris.com/More/Compliance/Application%20Security"},
            {name: "Best Practices", link: "https://developer.moneris.com/More/Compliance/Best%20Practices"},
            {name: "Security Requirements", link: "https://developer.moneris.com/More/Compliance/Security%20Requirements"},
            {name: "Sample Return Policy", link: "https://developer.moneris.com/More/Compliance/Sample%20Return%20Policy"},
            {name: "Sample Delivery Policy", link: "https://developer.moneris.com/More/Compliance/Sample%20Delivery%20Policy"},
            {name: "Sample Terms of Use", link: "https://developer.moneris.com/More/Compliance/Sample%20Terms%20of%20Use"},
            {name: "Sample Privacy Policy", link: "https://developer.moneris.com/More/Compliance/Sample%20Privacy%20Policy"},
            {name: "eCommerce Requirements", link: "https://developer.moneris.com/More/Compliance/eCommerce%20Requirements"},
            {name: "Payment Network", link: "https://developer.moneris.com/More/Compliance/Payment%20Network"}
        ]
    },
    {
        title: "Help and Support",
        elements: [
            {name: "FAQ", link: "https://developer.moneris.com/More/Help/Knowledgebase"},
            {name: "Payment Glossary", link: "https://developer.moneris.com/More/Help/Payment%20Glossary"},
            {name: "How do I get help?", link: "https://developer.moneris.com/More/Help/How%20do%20I%20get%20help"}
        ]
    },
]

export default LISTS